import { Pipe, PipeTransform } from "@angular/core";

type Primitive = string | number | boolean | Date;
type SortableRecord = Record<string, Primitive>;

@Pipe({
    name: "orderBy"
})
export class OrderByPipe implements PipeTransform {
    transform(array: SortableRecord[], field: string): SortableRecord[] {
        array.sort((a: SortableRecord, b: SortableRecord) => {
            if (a[field] < b[field]) {
                return -1;
            } else if (a[field] > b[field]) {
                return 1;
            } else {
                return 0;
            }
        });
        return array;
    }
}

// doesn't modify original array
@Pipe({
    name: "orderByLocal"
})
export class OrderByLocalPipe implements PipeTransform {
    transform(array: SortableRecord[], field: string, order: "asc" | "desc" = "asc"): SortableRecord[] {
        if (!Array.isArray(array) || !field) {
            return array;
        }

        const sortedArray = array.slice().sort((a, b) => {
            if (a[field] < b[field]) {
                return order === "asc" ? -1 : 1;
            } else if (a[field] > b[field]) {
                return order === "asc" ? 1 : -1;
            } else {
                return 0;
            }
        });

        return sortedArray;
    }
}
